import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { FranchiseeService } from 'app/franchisee/franchisee.service';
import { openSnackbar } from 'app/store/actions/page.action';
import { ISelectItem } from 'app/store/models/select.model';
import { IReducers } from 'app/store/reducers';
import { ButtonDisablerService } from 'app/store/services/button-disabler.service';

@Component({
  selector: 'app-register-referral',
  templateUrl: './register-referral.component.html',
  styleUrls: ['./register-referral.component.scss']
})
export class RegisterReferralComponent implements OnInit {

  formGroup: FormGroup | null = null;

  confirmationToken: string | null = null;

  get accountTypeOptions(): ISelectItem[] {
    return [
      { label: 'Checking', value: 'checking' },
      { label: 'Savings', value: 'savings' }
    ]
  }

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly franchiseService: FranchiseeService,
    private readonly store$: Store<IReducers>,
    private readonly buttonDisablerService: ButtonDisablerService
  ) { }

  ngOnInit(): void {
    this.confirmationToken = this.activatedRoute.snapshot.queryParamMap.get('confirmation_token') || null;

    if(!this.confirmationToken) {
      this.router.navigate(['/']);
      return;
    }

    this.franchiseService.viewReferralPartnerByConfirmationToken(this.confirmationToken).subscribe(res => {
      this.formGroup = new FormGroup({
        name: new FormControl(res.name, [Validators.required]),
        contact_email: new FormControl(res.contact_email, [Validators.required, Validators.email]),
        contact_phone: new FormControl(res.contact_phone, [Validators.required]),
        company_name: new FormControl(res.company_name, [Validators.required]),
        address: new FormControl(res.address, [Validators.required]),
        ach_account_number: new FormControl(res.ach_account_number, [Validators.required]),
        ach_account_type: new FormControl(res.ach_account_type || 'checking', [Validators.required, Validators.pattern('^(checking|savings)$')]),
        tax_id: new FormControl(res.tax_id, [Validators.required]),
        w9_on_file: new FormControl(res.w9_on_file),
        w9_filed_at: new FormControl(res.w9_filed_at),
        ach_routing_number: new FormControl(res.ach_routing_number, [Validators.required, Validators.minLength(9), Validators.maxLength(9), Validators.pattern('^[0-9]*$')]),
        confirmation_token: new FormControl(this.confirmationToken)
      });
    }, err => {
      this.router.navigate(['/']);
      this.store$.dispatch(openSnackbar({
        snackbarData: {
          data: {
            message: 'Invalid referral confirmation token.',
            type: 'error'
          },
          duration: 5000
        }
      }))
    });
  }


  onSubmit = () => {
    if(!this.formGroup || !this.formGroup.valid) {
      this.formGroup?.markAllAsTouched();
      this.buttonDisablerService.disableActive();
      return;
    }

    const data = this.formGroup.value;

    // get the date only in date (Y-m-d)
    data['w9_filed_at'] = data['w9_filed_at'] ? new Date(data['w9_filed_at']).toISOString().split('T')[0] : null;

    this.franchiseService.registerReferral(data).subscribe(() => {
      this.router.navigate(['/']);
      this.store$.dispatch(openSnackbar({
        snackbarData: {
          data: {
            message: 'Referral registration successful. You can now log in to your account.',
            type: 'success',
          },
          duration: 5000
        }
      }))
    }, err => this.store$.dispatch(openSnackbar({
      snackbarData: {
        data: {
          message: err.error,
          type: 'error'
        },
        duration: 5000
      }
    })));
  }

  onW9OnFileChange(event: any) {
    const w9OnFile = event.checked;
    if(w9OnFile) {
      this.formGroup?.get('w9_filed_at')?.setValidators([Validators.required]);
    } else {
      this.formGroup?.get('w9_filed_at')?.clearValidators();
      this.formGroup?.get('w9_filed_at')?.setValue(null);
    }
    this.formGroup?.get('w9_filed_at')?.updateValueAndValidity();
  }

}
